import { NavLink } from "react-router-dom";
import { LogOut, Moon, Sun } from "lucide-react";

import { useStore } from "../context/StoreContext";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./branding";

export default function Sidebar({ nav }) {
  const { dark, setDark, documents } = useStore();
  const { user, logout } = useAuth();
  const hasUpdates = documents.some((d) => d.is_update);

  return (
    <aside className="hidden md:flex flex-col w-60 shrink-0 border-r border-border sticky top-0 h-screen bg-background">
      <div className="px-5 py-5">
        <Logo />
      </div>
      <nav className="px-3 flex-1 space-y-0.5">
        {nav.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-3 py-2 rounded-xl text-[13px] font-normal transition active:scale-[0.98] ${
                  isActive ? "bg-foreground/[0.08] text-foreground" : "text-muted hover:text-foreground"
                }`
              }
            >
              <Icon size={17} />
              {n.label}
              {n.to === "/documents" && hasUpdates ? (
                <span className="ml-auto w-1.5 h-1.5 rounded-full bg-foreground" />
              ) : null}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-3 space-y-1 border-t border-border/60">
        {user ? (
          <div className="px-3 pt-1 pb-1.5 min-w-0">
            <div className="text-[12.5px] text-foreground truncate">{user.full_name || "Signed in"}</div>
            <div className="text-[11.5px] text-faint truncate">{user.email}</div>
          </div>
        ) : null}
        <button
          onClick={() => setDark(!dark)}
          className="w-full flex items-center gap-2.5 text-[12.5px] text-muted px-3 py-2 rounded-xl transition hover:bg-foreground/5 hover:text-foreground"
        >
          {dark ? <Sun size={15} /> : <Moon size={15} />}
          {dark ? "Light mode" : "Dark mode"}
        </button>
        <button
          onClick={logout}
          className="w-full flex items-center gap-2.5 text-[12.5px] text-muted px-3 py-2 rounded-xl transition hover:bg-foreground/5 hover:text-foreground"
        >
          <LogOut size={15} />
          Sign out
        </button>
      </div>
    </aside>
  );
}